import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <div style={{ fontSize: "10px" }}>
      <Typewriter
        options={{
          strings: [
            "AI & Backend Engineer (Python | Django)",
            "LLM & RAG Systems Developer",
            "Production Grade API & Backend Architect",
            "AI Agent & Automation Engineer",
            "OpenAI & GPT Integration Specialist",
            "Scalable Backend & SaaS System Builder"
          ],
          autoStart: true,
          loop: true,
          deleteSpeed: 50,
        }}
      />
    </div>
  );
}

export default Type;